module.exports = __webpack_public_path__ + "static/media/sheaffer.9d1b26db.png";